import { render } from "./MessagesManager.vue?vue&type=template&id=3af2146c&scoped=true"
import script from "./MessagesManager.vue?vue&type=script&lang=js"
export * from "./MessagesManager.vue?vue&type=script&lang=js"

import "./MessagesManager.vue?vue&type=style&index=0&id=3af2146c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af2146c"]])

export default __exports__